export enum EntityType {
  Company,
  Trust,
  Individual,
}